export default __webpack_public_path__ + "static/media/provesional_restoration_upper_17_4@2x.ad09c0c2.png";